export default __webpack_public_path__ + "static/media/my-journey-footer.e237854e.svg";